import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

         
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            // For admin routes, also require isAdmin flag
            console.debug('AuthGuard checking access for route:', state.url, 'Current user:', currentUser);
            if (state.url.startsWith('/admin') && !currentUser.isAdmin) {
                this.router.navigate(['/portal']);
                return false;
            }
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}